import Template from "backbone/projects/templates/import_status.js.hamlc"
import Inflector from 'utils/platform/inflector.js'

export default class ImportStatusView extends Backbone.View
  initialize: ->
    @collection = @options.collection
    @showWarning = @options.showWarning
    @importComplete = @options.importComplete
    @listenTo(@collection, "change", @checkStatus)
    @inflector = new Inflector()

  render: ->
    @$el.html(
      Template(
        collection: @collection
        showWarning: @showWarning
        inflector: @inflector
      )
    )

  checkStatus: ->
    if @collection.importComplete()
      @importComplete()
    else
      @render()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/import_status_view.js.coffee